import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';

class GeoWeighing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sorting: this.props.sorting
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            sorting: nextProps.sorting
        });
    }

    render() {
        let choices = [
            {
                id: "NOFIT",
                image: "no_fit.png",
                title: this.props.t("GeoWeighing_NoFit"),
                intro: this.props.t("GeoWeighing_NoFitIntro"),
                disabled: false
            },
            {
                id: "BALANCED",
                image: "balanced_fit.png",
                title: this.props.t("GeoWeighing_BalancedFit"),
                intro: this.props.t("GeoWeighing_BalancedFitIntro"),
                disabled: this.props.measure === 'no'
            },
            {
                id: "GUARANTEEDFIT",
                image: "guaranteed_fit.png",
                title: this.props.t("GeoWeighing_GuaranteedFit"),
                intro: this.props.t("GeoWeighing_GuaranteedFitIntro"),
                disabled: this.props.measure === 'no'
            },
        ];

        let choiceContent = choices.map((item, i) => {
            let checked = this.state.sorting === item.id;

            return (
                <div key={item.id} className={"col-12 option option-" + (i + 1)}>
                    <div className="row">
                        <div className="col-sm-7" style={{background: "url(/img/" + item.image + ")"}}>
                        </div>
                        <div className="col-sm-4 vcenter">
                            <div>
                                <h3>{item.title}</h3>
                                <span>{item.intro}</span>
                            </div>
                        </div>
                        <div className="col-sm-1 vcenter">
                            <div>
                                <input type="radio" name="geo-weighing" checked={checked}
                                       disabled={item.disabled} onChange={() => this.handleChange(item.id)}/>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });

        return (
            <div className="container main">
                <form className="mt-4 geo-weighing horizontal-options" onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-12 text-center title">
                            <h2>{this.props.t('GeoWeighing_Title')}</h2>
                        </div>
                        {choiceContent}
                    </div>
                    <div className="row">
                        <div className="col-6 text-left">
                            <button className="back btn btn-link" onClick={this.goBack}><i
                                className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
                        </div>
                        <div className="col-6 text-right">
                            <input id="reset-button" className="btn btn-default" type="button" onClick={this.submitDefaultConfig}
                                   value={this.props.t('PartWeighing_ReloadDefaults')}/>
                            <input id="submitbtn" className="btn btn-secondary" type="submit"
                                   value={this.props.t('Apply')}/>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    goBack = (e) =>  {
        e.preventDefault();
        this.props.goTo('/advice/result', this.props.traject);
    };

    handleChange = (value) => {
        this.setState({sorting: value});
    };

    submitDefaultConfig = () => {
        this.props.setSorting('BALANCED').then(() => this.props.goTo('/advice/result', this.props.traject));
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.setSorting(this.state.sorting).then(() => this.props.goTo('/advice/result', this.props.traject));
    };
}

export default withTranslation('result')(GeoWeighing);